import {BRANCHES_REQUEST, BRANCHES_SUCCESS, BRANCHES_FAILURE} from '../actions';
import {STORE_BRANCH_REQUEST, STORE_BRANCH_SUCCESS, STORE_BRANCH_FAILURE} from '../actions';
import {UPDATE_BRANCH_REQUEST, UPDATE_BRANCH_SUCCESS, UPDATE_BRANCH_FAILURE} from '../actions';
import branchReducer from './branch';

export const BRANCHES_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const updateBranch = (state, action) => {
    let {data} = state;
    const {id} = action;
    const branch = data.find(b => b.id === id);
    data.splice(data.indexOf(branch), 1);
    const reduced = branchReducer(branch, action);
    data = [...state.data, reduced];

    return {...state, data};
};

const branchesReducers = {
    [BRANCHES_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [BRANCHES_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [BRANCHES_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_BRANCH_REQUEST]: (state, action) => {
        const branch = branchReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), branch];

        return {...state, data};
    },
    [STORE_BRANCH_SUCCESS]: (state, action) => {
        let {data} = state;
        const branch = data.find(b => b.draft);
        data.splice(data.indexOf(branch), 1);
        const reduced = branchReducer(branch, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_BRANCH_FAILURE]: (state, action) => {
        let {data} = state;
        const branch = data.find(b => b.draft);
        data.splice(data.indexOf(branch), 1);
        const reduced = branchReducer(branch, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_BRANCH_REQUEST]: updateBranch,
    [UPDATE_BRANCH_SUCCESS]: updateBranch,
    [UPDATE_BRANCH_FAILURE]: updateBranch
};

export default function branches(state = BRANCHES_INITIAL_STATE, action) {
    let reducer = branchesReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/branches.js